import React from 'react';

const CalculateRateShowHeader = ({ activeTab, setActiveTab }) => {
    return (
        <div className="bg-white rounded-lg">
            {/* Buttons */}
            <div className="mt-4 flex gap-2 border-b">
                {["Forward", "RTO"].map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`px-4 py-2 text-sm  ${activeTab === tab
                            ? "font-semibold text-black bg-blue-100 rounded-t-md border-b-2 border-black"
                            : "text-gray-600 hover:text-black"
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CalculateRateShowHeader;
